import _createForOfIteratorHelper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useReducer } from 'react';
import { useEthers, useLocalStorage, useConfig } from '../../hooks';
import { useIsMounted } from '../../hooks/useIsMounted';
import { useNotificationsContext } from '../notifications/context';
import { TransactionsContext } from './context';
import { DEFAULT_STORED_TRANSACTIONS } from './model';
import { transactionReducer } from './reducer';
export function TransactionProvider(_ref) {
  var children = _ref.children;
  var _useEthers = useEthers(),
    chainId = _useEthers.chainId,
    library = _useEthers.library;
  var _useConfig = useConfig(),
    localStorage = _useConfig.localStorage;
  var _useLocalStorage = useLocalStorage(localStorage.transactionPath),
    _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
    storage = _useLocalStorage2[0],
    setStorage = _useLocalStorage2[1];
  var _useReducer = useReducer(transactionReducer, storage !== null && storage !== void 0 ? storage : DEFAULT_STORED_TRANSACTIONS),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    transactions = _useReducer2[0],
    dispatch = _useReducer2[1];
  var _useNotificationsCont = useNotificationsContext(),
    addNotification = _useNotificationsCont.addNotification;
  var isMounted = useIsMounted();
  useEffect(function () {
    setStorage(transactions);
  }, [transactions]);
  var addTransaction = useCallback(function (payload) {
    if (!isMounted()) {
      return;
    }
    dispatch({
      type: 'ADD_TRANSACTION',
      payload: payload
    });
    if (payload.receipt) {
      var type = payload.receipt.status === 0 ? 'transactionFailed' : 'transactionSucceed';
      addNotification({
        notification: {
          type: type,
          submittedAt: Date.now(),
          transaction: payload.transaction,
          receipt: payload.receipt,
          transactionName: payload.transactionName
        },
        chainId: payload.transaction.chainId
      });
      return;
    }
    addNotification({
      notification: {
        type: 'transactionStarted',
        transaction: payload.transaction,
        submittedAt: payload.submittedAt,
        transactionName: payload.transactionName
      },
      chainId: payload.transaction.chainId
    });
  }, [dispatch]);
  var updateTransaction = useCallback(function (payload) {
    if (!isMounted()) {
      return;
    }
    dispatch({
      type: 'UPDATE_TRANSACTION',
      payload: payload
    });
    var type = payload.receipt.status === 0 ? 'transactionFailed' : 'transactionSucceed';
    addNotification({
      notification: {
        type: type,
        submittedAt: Date.now(),
        transaction: payload.transaction,
        receipt: payload.receipt,
        transactionName: payload.transactionName
      },
      chainId: payload.transaction.chainId
    });
  }, [dispatch]);
  useEffect(function () {
    var updateTransactions = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _a, blockNumber, checkTransaction, chainTransactions, newTransactions, _iterator, _step, tx, newTransaction;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!chainId || !library)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.next = 4;
              return library.getBlockNumber();
            case 4:
              blockNumber = _context2.sent;
              checkTransaction = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(tx) {
                  var receipt, type;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (!(tx.receipt || !shouldCheck(blockNumber, tx))) {
                          _context.next = 2;
                          break;
                        }
                        return _context.abrupt("return", tx);
                      case 2:
                        _context.prev = 2;
                        _context.next = 5;
                        return library.getTransactionReceipt(tx.transaction.hash);
                      case 5:
                        receipt = _context.sent;
                        if (!receipt) {
                          _context.next = 12;
                          break;
                        }
                        type = receipt.status === 0 ? 'transactionFailed' : 'transactionSucceed';
                        addNotification({
                          notification: {
                            type: type,
                            submittedAt: Date.now(),
                            transaction: tx.transaction,
                            receipt: receipt,
                            transactionName: tx.transactionName
                          },
                          chainId: chainId
                        });
                        return _context.abrupt("return", Object.assign(Object.assign({}, tx), {
                          receipt: receipt
                        }));
                      case 12:
                        return _context.abrupt("return", Object.assign(Object.assign({}, tx), {
                          lastCheckedBlockNumber: blockNumber
                        }));
                      case 13:
                        _context.next = 18;
                        break;
                      case 15:
                        _context.prev = 15;
                        _context.t0 = _context["catch"](2);
                        console.error("failed to check transaction hash: ".concat(tx.transaction.hash), _context.t0);
                      case 18:
                        return _context.abrupt("return", tx);
                      case 19:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee, null, [[2, 15]]);
                }));
                return function checkTransaction(_x) {
                  return _ref3.apply(this, arguments);
                };
              }();
              chainTransactions = (_a = transactions[chainId]) !== null && _a !== void 0 ? _a : [];
              newTransactions = [];
              _iterator = _createForOfIteratorHelper(chainTransactions);
              _context2.prev = 9;
              _iterator.s();
            case 11:
              if ((_step = _iterator.n()).done) {
                _context2.next = 19;
                break;
              }
              tx = _step.value;
              _context2.next = 15;
              return checkTransaction(tx);
            case 15:
              newTransaction = _context2.sent;
              newTransactions.push(newTransaction);
            case 17:
              _context2.next = 11;
              break;
            case 19:
              _context2.next = 24;
              break;
            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2["catch"](9);
              _iterator.e(_context2.t0);
            case 24:
              _context2.prev = 24;
              _iterator.f();
              return _context2.finish(24);
            case 27:
              if (isMounted()) {
                dispatch({
                  type: 'UPDATE_TRANSACTIONS',
                  chainId: chainId,
                  transactions: newTransactions
                });
              }
            case 28:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[9, 21, 24, 27]]);
      }));
      return function updateTransactions() {
        return _ref2.apply(this, arguments);
      };
    }();
    void updateTransactions();
  }, [chainId, library]);
  return _jsx(TransactionsContext.Provider, {
    value: {
      transactions: transactions,
      addTransaction: addTransaction,
      updateTransaction: updateTransaction
    },
    children: children
  });
}
function shouldCheck(blockNumber, tx) {
  if (tx.receipt) {
    return false;
  }
  if (!tx.lastCheckedBlockNumber) {
    return true;
  }
  var blocksSinceCheck = blockNumber - tx.lastCheckedBlockNumber;
  if (blocksSinceCheck < 1) {
    return false;
  }
  var minutesPending = (Date.now() - tx.submittedAt) / 1000 / 60;
  if (minutesPending > 60) {
    // every 10 blocks if pending for longer than an hour
    return blocksSinceCheck > 9;
  }
  if (minutesPending > 5) {
    // every 3 blocks if pending more than 5 minutes
    return blocksSinceCheck > 2;
  }
  // otherwise every block
  return true;
}